import request from "../../components/request";
import { resetPills } from "./reset";

$("#calculate-kidney-liver").on("click", function () {
  const value = $("#weights_for_kidney").val();
  if (value != "Wybierz") {
    $("#wrapper-kidney-liver").removeClass("d-none");
    $("#loader-kidney-liver").removeClass("d-none").addClass("d-flex");
    $("#data-kidney-liver").addClass("d-none");
    asyncGetDataKidneyAndLiver(value);
  } else {
    $("#wrapper-kidney-liver").addClass("d-none");
  }
  resetPills();
});

async function asyncGetDataKidneyAndLiver(value) {
  const kidney = await request("calculator", "kidney", { weight: value });
  const liver = await request("calculator", "liver", { weight: value });
  setDataKidneyAndLiver(kidney, liver);
}

function setDataKidneyAndLiver(kidney, liver) {
  $("#dose-kidneys").html(kidney.dose);
  $("#dose-min-liver").html(liver.dose.min);
  $("#dose-max-liver").html(liver.dose.max);
  $("#loader-kidney-liver").removeClass("d-flex").addClass("d-none");
  $("#data-kidney-liver").removeClass("d-none").fadeIn(300);
}
